import React, { useState } from 'react';
// import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import { data } from "./projectData";
import FloatingBall from './FloatingBall';
function Project() {

    const [showAll, setShowAll] = useState(false);

    const visibleProjects = showAll ? data : data.slice(0, 3);

    const visitIcon = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-play-circle-fill" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
    </svg>

    const gitIcon = <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-github" viewBox="0 0 16 16">
        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
    </svg>

    return (
        <>
            <FloatingBall />
            <section className="project-section">

                <div className="project-window">

                    <div className="window-topbar">

                        <div className="window-dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        <div className="window-title">
                            divsProjects.fig
                        </div>

                    </div>

                    <Container className='project_wrap'>

                        <h2 className='text-center p-4'>
                            Projects I've worked on.!
                        </h2>
                        <Row xs={1} md={2} lg={3} className="g-4 project-grid">

                            {visibleProjects?.map((project) => {
                                return (
                                    <Col key={project.id}>

                                        <div className="neon-project-card">

                                            <div className="project-image-wrapper">

                                                <img
                                                    src={project.img}
                                                    alt={project.title}
                                                    className="project-image"
                                                />

                                                <div className="project-overlay"></div>

                                                <div className="project-tech">
                                                    {project.tech}
                                                </div>

                                                <div className="project-buttons">

                                                    <a
                                                        href={project.liveLink}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="neon-btn"
                                                    >
                                                        {visitIcon}
                                                    </a>

                                                    <a
                                                        href={project.gitLink}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="neon-btn"
                                                    >
                                                        {gitIcon}
                                                    </a>

                                                </div>

                                                <div className="project-info">

                                                    <h3>{project.title}</h3>

                                                    <p>
                                                        {project.description}
                                                    </p>

                                                    <span>{project.date}</span>

                                                </div>

                                            </div>

                                        </div>

                                    </Col>
                                )
                            })}

                        </Row>
                        <div className="expand-wrapper">

                            <button
                                className="expand-btn"
                                onClick={() => setShowAll(!showAll)}
                            >
                                {showAll ? "Show Less" : "Show More Projects"}
                            </button>

                        </div>

                    </Container>
                </div>

            </section>
        </>
    );
}

export default Project;